import { useCurrentOrganization } from 'pages/organization/CurrentOrganizationContext';
import { isChildOrganization } from 'lib/organizations';

export default () => {
  const organization = useCurrentOrganization();
  return isChildOrganization(organization);
};
